import { render, staticRenderFns } from "./BusinessSmartId.vue?vue&type=template&id=31922a4c&"
import script from "./BusinessSmartId.vue?vue&type=script&lang=js&"
export * from "./BusinessSmartId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports